import styled from 'styled-components';

/**
 * Re-export styles from InsufficientPermissions that can be reused.
 * Only define new styles specific to this page.
 */
export {
  InsufficientPermissionsWrap as PageWrapper,
  InsufficientPermissionsTop as ContentArea,
  InsufficientPermissionsLogo as Logo,
  InsufficientPermissionsTextHeader as Title,
  InsufficientPermissionsTextRegular as Message,
  InsufficientPermissionsText as MessageContainer,
} from '@common/components/InsufficientPermissions/styles';

export const ErrorMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: ${({ theme }) => theme.colors.red};

  p {
    margin: 10px 0;
  }
`;
